<template>
	<v-container fluid>
		<v-row
			class="bgc1 mt-2 padMobile"
			style="padding: 0 60px"
			justify="center"
			align="center"
		>
			<v-col cols="12" md="5" class="d-flex justify-center flex-column">
				<div>
					<v-img
						src="../assets/beneficius/logobeneficius.png"
						contain
						width="395"
					></v-img>
					<h1
						class="mt-5 textmobile"
						style="
							color: #fff;
							font-size: 1.6rem;
							font-weight: 600;
							line-height: 1.2;
						"
					>
						Conheça o primeiro clube de <br />
						Benefícios em Tokens do Brasil.
					</h1>
				</div>
				

				<p style="color: #fff" class="mt-5">
					A Beneficius é um clube de vantagens que proporciona
					descontos em diversos serviços e produtos para você e sua
					família, desde serviços imobiliários até entretenimento e
					lazer. <br />
					<b style="color: #fe9a29">
						Não perca a oportunidade de se tornar um membro e comece
						a desfrutar de tudo o que a Beneficius tem a oferecer!
					</b>
				</p>

				<div
					v-if="intBreakPoint > 2"
					class="d-flex mt-10 flexMob"
					style="gap: 1rem"
				>
					<a
						href="https://app.ribus.com.br/cadastro/dados-acesso"
						target="_blank"
					>
						<v-btn class="formatBtn" style="font-weight: 500"
							>CADASTRE-SE</v-btn
						>
					</a>
					<!-- <v-spacer></v-spacer> -->
					<a href="https://ribus.convenia.com.br/" target="_blank">
						<v-btn class="formatBtn" style="font-weight: 500"
							>JÁ TENHO ACESSO</v-btn
						>
					</a>
				</div>

				<div
					v-if="intBreakPoint < 2"
					class="d-flex mt-10 flexMob"
					style="gap: 1rem"
				>
					<a
						href="https://app.ribus.com.br/cadastro/dados-acesso"
						target="_blank"
					>
						<v-btn class="formatBtn" block style="font-weight: 500"
							>CADASTRE-SE</v-btn
						>
					</a>
					<!-- <v-spacer></v-spacer> -->
					<a href="https://ribus.convenia.com.br/" target="_blank">
						<v-btn class="formatBtn" block style="font-weight: 500"
							>JÁ TENHO ACESSO</v-btn
						>
					</a>
				</div>
			</v-col>


			<v-col cols="12" md="6">
				
			</v-col>
		</v-row>

		<!-- <v-row style="margin-top: -160px" class="marginTMobile">
			<v-col
				cols="12"
				md="12"
				class="mt-5"
				style="padding: 0px !important"
			>
				<v-sheet class="mx-auto" style="background-color: transparent">
					<v-slide-group
						v-model="currentSlide"
						class="pa-4"
						center-active
						selected-class="bg-success"
						show-arrows
					>
						<v-slide-item
							v-for="descontos in club"
							:key="descontos.logo"
							:name="descontos.name"
							style="margin: 0 10px"
						>
							<v-card
								@click="
									logado
										? abrirLink()
										: $router.push('/descricaoClube')
								"
								style="padding: 10px"
								width="180"
								height="250"
								class="alinhadoM colorCard efeito-vidro sizeCard"
							>
								<v-img
									:src="descontos.logo"
									width="150"
									contain
								></v-img>
						
							</v-card>
						</v-slide-item>
			
					</v-slide-group>
				</v-sheet>
			</v-col>
		</v-row> -->

		<v-row class="bgc2 mt-10">
			<v-col
				cols="12"
				md="6"
				offset-md="6"
				class="d-flex justify-center flex-column"
			>
				<h1>Como a Beneficius funciona</h1>
				<p>
					A Beneficius foi criada pensando especialmente em você,
					Tokenista Ribus, para trazer inúmeras vantagens e
					oportunidades para o seu dia a dia, além de estar presente
					em seus momentos mais especiais. Com a Beneficius, você tem
					acesso exclusivo à descontos em Contratação de Parceiros,
					Hospedagens e Produtos.
				</p>

				<!-- <router-link to="descricaoClube"> -->
				<a
					href="https://app.ribus.com.br/cadastro/dados-acesso"
					target="_blank"
				>
					<v-btn class="formatBtn" width="45vw">CADASTRE-SE</v-btn>
				</a>
				<!-- </router-link> -->
			</v-col>
		</v-row>

		<v-row class="bgc3 mt-10 padMobile">
			<v-col cols="12" md="12" class="d-flex justify-center">
				<h1 style="color: #fff">CONHEÇA TODOS OS BENEFÍCIOS</h1>
			</v-col>
			<div class="d-flex flex-column" style="width: 100%">
				<v-row>
					<v-col
						cols="6"
						md="3"
						class="d-flex justify-center align-center flex-column"
					>
						<router-link to="/descricaoClube">
							<v-card
								class="efeito-vidro2 d-flex justify-center align-center flex-column"
								style="
									padding: 10px;
									width: 230px;
									height: 230px;
								"
							>
								<img src="../assets/icon1.png" width="70" />
								<h1
									style="
										font-size: 1.5rem;
										text-align: center;
										line-height: 1;
									"
									class="fontMobile"
								>
									CLUBE DE DESCONTOS
								</h1>
							</v-card>
						</router-link>
					</v-col>

					<v-col
						cols="6"
						md="3"
						class="d-flex justify-center align-center flex-column"
					>
						<router-link to="/beneficiusParceiros">
							<v-card
								class="efeito-vidro2 d-flex justify-center align-center flex-column"
								style="
									padding: 10px;
									width: 230px;
									height: 230px;
								"
							>
								<img src="../assets/icon2.png" width="70" />
								<h1
									style="font-size: 1.5rem"
									class="fontMobile"
								>
									SERVIÇOS
								</h1>
							</v-card>
						</router-link>
					</v-col>

					<v-col
						cols="6"
						md="3"
						class="d-flex justify-center align-center flex-column"
					>
						<v-card
							@click="embreve = true"
							class="efeito-vidro2 d-flex justify-center align-center flex-column"
							style="padding: 10px; width: 230px; height: 230px"
						>
							<div class="tipsOrange">
								<span>Em breve</span>
							</div>
							<img src="../assets/icon3.png" width="70" />
							<h1 style="font-size: 1.5rem" class="fontMobile">
								PRODUTOS
							</h1>
						</v-card>
					</v-col>

					<v-col
						cols="6"
						md="3"
						class="d-flex justify-center align-center flex-column"
					>
						<v-card
							@click="embreve = true"
							class="efeito-vidro2 d-flex justify-center align-center flex-column"
							style="padding: 10px; width: 230px; height: 230px"
						>
							<div class="tipsOrange">
								<span>Em breve</span>
							</div>
							<img src="../assets/icon4.png" width="70" />
							<h1 style="font-size: 1.5rem" class="fontMobile">
								HOSPEDAGENS
							</h1>
						</v-card>
					</v-col>

					<v-col
						cols="12"
						md="5"
						class="d-flex justify-center align-center flex-column"
					>
						<v-img src="../assets/moeda.png" width="350"></v-img>
					</v-col>

					<v-col cols="12" md="7" class="d-flex align-center">
						<h1
							style="
								color: #fff;
								line-height: 1.2;
								font-weight: 400;
								font-size: 2.4rem;
							"
						>
							Não perca mais tempo, <br />
							utilize seus <b> Tokens Ribus <br /> </b> para ter
							<b> muitos Benefícios! </b>
						</h1>
					</v-col>
				</v-row>
			</div>
		</v-row>

		<v-row class="mt-10 padMobile" style="padding: 50px 0px">
			<v-col cols="12" md="12" class="d-flex justify-center">
				<h1 style="color: #00192c">Perguntas frequentes</h1>
			</v-col>
			<v-col cols="12" md="10" offset-md="1">
				<v-expansion-panels
					style="box-shadow: none !important"
					variant="popout"
				>
					<v-expansion-panel class="">
						<img
							contain
							src="../assets/iconBen.png"
							width="30"
							style="
								position: absolute;
								top: 10px;
								box-shadow: none !important;
								border: !important;
								left: 5px;
								max-width: 30 !important;
								width: 30 !important;
							"
						/>
						<v-expansion-panel-header style="padding-left: 60px">
							O que é a Beneficius?
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							A Beneficius é o clube de vantagens oficial da
							Ribus, que oferece benefícios exclusivos aos seus
							Tokenistas. Ao aderir à plataforma, você terá acesso
							a descontos inigualáveis em diversas lojas e redes
							do Brasil, o que significa mais economia nas suas
							compras. Além disso, ao fazer parte da Beneficius,
							você poderá maximizar sua experiência com a Ribus e
							desfrutar de mais vantagens ao fazer parte do nosso
							Ecossistema.
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel class="">
						<img
							contain
							src="../assets/iconBen.png"
							width="30"
							style="
								position: absolute;
								top: 10px;
								box-shadow: none !important;
								border: !important;
								left: 5px;
								max-width: 30 !important;
								width: 30 !important;
							"
						/>
						<v-expansion-panel-header style="padding-left: 60px">
							Como participo da Beneficius?
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							O cadastro na Beneficius é muito fácil e gratuito.
							Para ter acesso aos benefícios exclusivos do nosso
							clube de vantagens, basta ser Tokenista Ribus e ter
							o mínimo de 100 tokens em sua carteira. Depois
							disso, você pode se cadastrar na nossa plataforma
							facilmente e começar a aproveitar todas as vantagens
							que oferecemos aos nossos membros.
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel class="">
						<img
							contain
							src="../assets/iconBen.png"
							width="30"
							style="
								position: absolute;
								top: 10px;
								box-shadow: none !important;
								border: !important;
								left: 5px;
								max-width: 30 !important;
								width: 30 !important;
							"
						/>
						<v-expansion-panel-header style="padding-left: 60px">
							Quais são as vantagens de aderir à Beneficius?
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							Ao se tornar um membro da Beneficius, você terá
							acesso a descontos exclusivos nas maiores lojas e
							redes do Brasil, o que significa economia em suas
							compras. A Beneficius possui parcerias com diversas
							lojas e redes renomadas, oferecendo vantagens
							inigualáveis para seus membros. Além disso, ao fazer
							parte da nossa plataforma, você poderá maximizar sua
							experiência com a Ribus e ter ainda mais vantagens
							ao fazer parte do nosso Ecossistema. Venha fazer
							parte da Beneficius agora mesmo e aproveite todas as
							vantagens que só nosso clube pode oferecer!
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel class="">
						<img
							contain
							src="../assets/iconBen.png"
							width="30"
							style="
								position: absolute;
								top: 10px;
								box-shadow: none !important;
								border: !important;
								left: 5px;
								max-width: 30 !important;
								width: 30 !important;
							"
						/>
						<v-expansion-panel-header style="padding-left: 60px">
							Quais são as lojas e redes parceiras da Beneficius?
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							A Beneficius possui parcerias com diversas lojas e
							redes renomadas, oferecendo descontos e vantagens
							exclusivas para seus membros. Algumas das principais
							lojas e redes parceiras são: Casas Bahia, Wizard,
							CNA, VIVARA, Ponto Frio, Renner, Sam’s Club,
							Carrefour, Cruzeiro do Sul, São Judas Universidade,
							Multilaser, Lenovo, C&C, FISK, Natura, O Boticário,
							Domino’s Pizza, Burguer King, Extra, Cinemark,
							Buser, ClickBus, C&A, Madeira Madeira, entre outras.
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel class="">
						<img
							contain
							src="../assets/iconBen.png"
							width="30"
							style="
								position: absolute;
								top: 10px;
								box-shadow: none !important;
								border: !important;
								left: 5px;
								max-width: 30 !important;
								width: 30 !important;
							"
						/>
						<v-expansion-panel-header style="padding-left: 60px">
							Como os Tokenistas podem aproveitar as vantagens da
							Beneficius?
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							Os Tokenistas da Ribus podem aproveitar as vantagens
							da Beneficius de forma fácil e rápida. Para isso,
							basta acessar a plataforma da Beneficius e buscar
							pelos descontos e benefícios oferecidos pelas lojas
							e redes parceiras. Ao escolher a oferta desejada, o
							Tokenista poderá resgatar o benefício através do seu
							código promocional exclusivo e utilizá-lo
							diretamente no site ou loja física da parceira. É
							importante lembrar que cada benefício possui suas
							próprias regras e condições de uso, que devem ser
							verificadas antes de resgatar a oferta.
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>
			</v-col>
		</v-row>

		<v-dialog
			v-model="embreve"
			class="d-flex align-end justify-end"
			width="40vw"
			style="box-shadow: none !important"
		>
			<v-card
				style="
					padding: 5px;
					background-color: transparent;
					gap: 1rem;
					box-shadow: none !important;
				"
				class="d-flex flex-column align-end"
			>
				<v-icon @click="embreve = false" color="#fff">mdi-close</v-icon>
				<img src="../assets/POPUP.png" style="width: 40vw !important" />
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
	@media (min-device-width: 300px) and (max-device-width: 855px) {
		.tipsOrange {
			width: 28vw !important;
		}
		.efeito-vidro2 {
			width: 170px !important;
			max-width: 170px !important;
		}
		.fontMobile {
			font-size: 1.1rem !important;
		}
		.bgc2 {
			background-image: url("../assets/banner4Mob.png") !important;
			background-size: cover;
			background-position: center;
			height: 100vh;
			padding: 180px 10px 10px 10px !important;

			background-repeat: no-repeat;
		}
		.bgc1 {
			background-image: url("../assets/v2mobile.png") !important;
			background-size: cover;
			background-position: center;
			height: 100vh;
			background-repeat: no-repeat;
		}
		.flexMob {
			flex-direction: column !important;
		}
		.textmobile {
			font-size: 1.2rem !important;
		}
		.footerBeneficius {
			padding: 15px !important;
		}
		.padMobile {
			padding: 15px !important;
		}

		.marginTMobile {
			margin-top: 0px !important;
		}

		.colorCard {
			background: linear-gradient(
				0deg,
				rgba(238, 241, 244, 1) 0%,
				rgba(254, 254, 254, 1) 100%
			);
			height: 178px !important;
		}
		.formatBtn {
			font-size: 1.1rem !important;
		}
	}

	.tipsOrange {
		background-color: #ff9411;
		width: 8vw;
		padding: 0;
		height: 26px;
		border-radius: 10px;
		margin: 0;
		display: flex;
		position: absolute;
		right: 0;
		justify-content: center;
		color: #fff;
		top: -1rem;
	}
	.formatBtn {
		background: linear-gradient(
			180deg,
			rgba(254, 169, 41, 1) 0%,
			rgba(252, 113, 28, 1) 100%
		);
		color: #fff;
		font-weight: 600;
		border-radius: 10px;
	}

	.bgc3 {
		background-image: url("../assets/banner3.jpg");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		padding: 60px 40px;
	}
	.bgc2 {
		background-image: url("../assets/banner4.jpg");
		background-size: cover;
		background-position: center;
		height: 100vh;
		padding: 0px 40px;

		background-repeat: no-repeat;
	}
	.efeito-vidro {
		background: rgb(255 255 255 / 33%) !important;
		/* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37) !important; */
		backdrop-filter: blur(3.5px) !important;
		-webkit-backdrop-filter: blur(3.5px) !important;
		border-radius: 10px !important;
		border: 1px solid rgba(255, 255, 255, 0.18) !important;
	}
	.efeito-vidro2 {
		background: rgba(255, 255, 255, 0.678) !important;
		/* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37) !important; */
		backdrop-filter: blur(1.5px) !important;
		-webkit-backdrop-filter: blur(3.5px) !important;
		opacity: 0.9;
		border-radius: 10px !important;
		border: 1px solid rgba(255, 255, 255, 0.18) !important;
	}
	.bgc1 {
		background-image: url("../assets/Grupo 252.png");
		background-size: cover;
		background-position: center;
		height: 100vh;
		background-repeat: no-repeat;
	}

	.colorCard:hover {
		height: 165px;
		transition: width 0s, height 0.5s, transform 0.5s;
	}

	.footerBeneficius {
		background-color: #042d4c;
		padding: 50px;
	}

	.etiqueta {
		background-color: #28e78e;
		padding: 8px;
		border-radius: 16px;
		/* height: 30px; */
		/* width: 193px; */
		margin: 11px 0;
	}

	.marginSlide {
		margin: 0 5px;
	}
	.colorCard {
		background: linear-gradient(
			0deg,
			rgba(238, 241, 244, 1) 0%,
			rgba(254, 254, 254, 1) 100%
		);
		height: 150px;
	}

	.btnMenu {
		background-color: transparent !important;
		box-shadow: none !important;
		color: #4d6a80 !important;
	}

	.seusRibus {
		background-image: url("../assets/beneficius/seusRibus.png");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
	.seusRibusMb {
		background-image: url("../assets/beneficius/simboloLogo.png");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		background-color: #042d4c;
	}

	.dialogBeneficius {
		background-image: url("../assets/beneficius/simboloLogo.png");
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		background-color: #042d4c;
		color: #fff !important;
	}
</style>

<script>
	import axios from "axios";
	export default {
		name: "Beneficius",
		data: () => ({
			currentSlide: 0,
			embreve: false,
			slideInterval: null,
			intervalTime: 500,
			dialog: false,
			logado: false,
			dialog2: false,
			club: [],
			leadEnviado: false,
			lead: {
				nome: "",
				email: "",
				telefone: "",
			},
			items: [],
			perguntas: [
				{
					pergunta: "O que é a Beneficius?",
					resposta:
						"A Beneficius é o clube de vantagens oficial da Ribus, criado para trazer maior usabilidade para o Token Ribus dentro do nosso Ecossistema, com benefícios exclusivos para nossos Tokenistas.",
				},
				// {
				// 	pergunta: "Quanto custa para participar da Beneficius?",
				// 	resposta: "",
				// },
				// {
				// 	pergunta: "Como funcionam os pagamentos dentro da Beneficius?",
				// 	resposta: "",
				// },
				// {
				// 	pergunta: "Posso usar meu Token Back da houseus na Beneficius?",
				// 	resposta: "",
				// },
			],
		}),

		mounted() {
			if (this.user.id) {
				this.logado = true;
				this.urlIndicacao =
					"https://marketplace.ribus.com.br/convite/" +
					this.user.login;
			}

			window.scrollTo(0, 0);
			this.items = this.$store.state.parceiros;

			this.getCategories();

			setInterval(() => {
				if (this.currentSlide >= this.club.length) {
					this.currentSlide = 0;
				}
				this.currentSlide = this.currentSlide + 1;
			}, this.intervalTime);
		},
		beforeDestroy() {
			clearInterval(this.slideInterval);
		},
		methods: {
			abrirLink() {
				window.open("https://ribus.convenia.com.br/");
			},
			getCategories() {
				axios
					.get(
						"https://clubecore.convenia.com.br/clube/v1/perks/490f64c0-cf28-11ed-ba42-b33a7838b52a"
					)
					.then((res) => {
						this.club = res.data.data.results;
						console.log(this.club);
					});
			},

			sanitizeTitle: function (title) {
				var slug = "";
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
				// Letter "a"
				slug = slug.replace(
					/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi,
					"a"
				);
				// Letter "o"
				slug = slug.replace(
					/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi,
					"o"
				);
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
				// Letter "d"
				slug = slug.replace(/đ/gi, "d");
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, "");
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, "-");

				return slug;
			},
			async enviarLead(e) {
				e.preventDefault();

				this.leadEnviado = true;

				if (this.lead.nome === "") {
					alert("Preencha todos os campos");
					return;
				} else if (this.lead.telefone === "") {
					alert("Preencha todos os campos");
					return;
				} else if (this.lead.email === "") {
					alert("Preencha todos os campos");
					return;
				}

				await fetch("https://gestao.abare.cloud/items/leads", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Accept: "application/json",
					},
					body: JSON.stringify({
						id_formulario: 180,
						lead: this.lead,
					}),
				}).then((response) => {
					response.text();
					console.log(response);
					this.leadEnviado = false;
					this.dialog = false;
					this.dialog2 = true;
					this.lead = {
						nome: "",
						email: "",
						telefone: "",
					};
				});
				// .then(() => {
				// 	setTimeout(() => {
				// 		location.reload();
				// 	}, 3000);
				// });
			},
		},

		computed: {
			user() {
				return this.$store.state.user;
			},
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case "xs":
						return 0;
					case "sm":
						return 1;
					case "md":
						return 2;
					case "lg":
						return 3;
					case "xl":
						return 4;
					default:
						return 0;
				}
			},
		},

		watch: {
			show(nValue) {
				this.login = nValue;
			},
			user(nValue) {
				if (!nValue.id) {
					this.logado = false;
				}
			},
			"$store.state.parceirosPagination": {
				handler: function (arrParceiros) {
					this.pagination = arrParceiros;
				},
			},
			"$store.state.parceiros": {
				handler: function (arrParceiros) {
					this.items = arrParceiros;
					// window.scrollTo({
					// 	top: 250,
					// 	left: 0,
					// 	behavior: "smooth",
					// });
				},
				deep: true,
				immediate: true,
			},
		},
	};
</script>
